import {URL, METHOD, STORAGE_KEY} from "utils/constants";

const v3FetchRequest = ({path, method, params, queryParams, isMockRequest}) => {
  const headers = {"Content-Type": "application/json; charset=utf-8"};

  if (localStorage.getItem("redbrickToken") && !isMockRequest) {
    headers["Authorization"] = `Bearer ${localStorage.getItem(STORAGE_KEY.REDBRICK_TOKEN)}`;
  }

  let url = (!isMockRequest ? URL.V3_API : "") + path;
  if (queryParams) url += "?" + new URLSearchParams(queryParams).toString();

  return fetch(url, {
    headers,
    method,
    body: JSON.stringify(params),
  })
    .then(res => res.json())
    .then(data => {
      return data;
    });
};

export const request = {
  get(requestInfo) {
    return v3FetchRequest({method: METHOD.GET, ...requestInfo});
  },
  post(requestInfo) {
    return v3FetchRequest({method: METHOD.POST, ...requestInfo});
  },
  put(requestInfo) {
    return v3FetchRequest({method: METHOD.PUT, ...requestInfo});
  },
  patch(requestInfo) {
    return v3FetchRequest({method: METHOD.PATCH, ...requestInfo});
  },
  delete(requestInfo) {
    return v3FetchRequest({method: METHOD.DELETE, ...requestInfo});
  },
};
